import { ISelectOption } from '../../../../../../ui-toolkit';

export const HoldbackReasonOptions: ISelectOption<string>[] = [
  { label: 'Cashier Check', value: 'Cashier Check' },
  { label: 'FIRPTA Holdback', value: 'FIRPTA Holdback' },
  { label: 'HOA Violation Holdback', value: 'HOA Violation Holdback' },
  { label: 'Moveout/Post Closing Occupancy Holdback', value: 'Moveout/Post Closing Occupancy Holdback' },
  { label: 'Need Routing # Added', value: 'Need Routing # Added' },
  { label: 'Other Holdback', value: 'Other Holdback' },
  { label: 'Payoff Holdback', value: 'Payoff Holdback' },
  { label: 'Pending Disb. Instructions', value: 'Pending Disb. Instructions' },
  { label: 'Pending Invoice', value: 'Pending Invoice' },
  { label: 'Recording', value: 'Recording' },
  { label: 'Repair(s) Holdback', value: 'Repair(s) Holdback' },
  { label: 'Tax Holdback', value: 'Tax Holdback' },
  { label: 'Utility Holdback', value: 'Utility Holdback' },
];
